import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import {  Mail } from "lucide-react";

export const Nav = () => {
	return (
		<header className="sticky top-0 z-50 w-full border-b bg-white flex justify-center shadow-sm py-4">
			<div className="container flex items-center justify-between h-18 max-w-8xl px-4 sm:px-6 lg:px-8">
				{/* Logo */}
				<Link to="/" aria-label="Gova Engineering Home">
					<img
						src="/gova_logo.png"
						alt="Gova Engineering Logo"
						className="h-16 sm:h-20 w-auto"
					/>
				</Link>

				{/* Right Side: Email (Desktop) + Contact Us Button */}
				<div className="flex items-center gap-4">
					<a
						href="mailto:miguel@govaengineering.com"
						className="hidden md:flex items-center gap-2 text-sm font-medium hover:text-primary transition-colors"
						aria-label="Email Gova Engineering"
					>
						<Mail className="h-4 w-4" />
						miguel@govaengineering.com
					</a>

					<Button
						asChild
						className="font-semibold text-base mt-auto"
						variant="default"
						size="lg"
					>
						<Link to="/contact">
							Contact Us <Mail className="h-2 w-2 ml-2" />
						</Link>
					</Button>
				</div>
			</div>
		</header>
	);
};
